import { useTheme } from '@mui/material'
import { GridColDef, GridFilterModel, useGridApiRef } from '@mui/x-data-grid-premium'
import { useEntitiesFromSearch } from 'api/search'
import { useOrganizationView } from 'api/aws/organizations_table/useOrganizationView'
import { useUserItems } from 'api/aws/users/useUserItems'
import renderContactsColumns from 'components/DataGrid/createColumns/renderContactsColumns'
import GlobalDataGrid from 'components/DataGrid/GlobalDataGrid'
import dayjs from 'dayjs'
import { useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Contact } from 'types'

const defaultFilterModel: GridFilterModel = { items: [], quickFilterValues: [], quickFilterExcludeHiddenColumns: false }
const OrgContacts = () => {
  const { PK, SK } = useParams()
  const theme = useTheme()
  const apiRef = useGridApiRef()
  const navigate = useNavigate()
  const [selectedItem, setSelectedItem] = useState(null)
  const [infoOpen, setInfoOpen] = useState(false)
  const { data: users } = useUserItems()
  const { organizations } = useEntitiesFromSearch()
  const { organization, viewContacts = [], isParent } = useOrganizationView(PK)
  const contacts = useMemo(() => {
    if (!viewContacts || !viewContacts?.length) return []
    return viewContacts.map(c => {
      const orgId = c?.organizations?.[0]
      const relatedOrg = orgId ? organizations?.find(o => o?.org_uuid === orgId) : null
      return { ...c, rowId: c?.contacts_uuid, relatedOrg }
    })
  }, [viewContacts, organizations])
  const formatDateString = date => {
    if (!date) return ''
    return dayjs.isDayjs(date) ? date.format('MM/DD/YYYY') : dayjs(date).format('MM/DD/YYYY')
  }

  const openInfo = (contact: Contact) => {
    setSelectedItem(contact)
    setInfoOpen(true)
  }

  const closeInfo = () => {
    setInfoOpen(false)
    setSelectedItem(null)
  }
  const handleRowClick = (row: Contact) => {
    const route = `/contacts/${row?.contacts_uuid}/details`
    navigate(route)
  }
  const dynamicFont = { xs: 12, sm: 13, md: 14, lg: 16 }
  const columns = useMemo(() => {
    if (!contacts || !contacts?.length) return []
    return renderContactsColumns('standard', handleRowClick) as GridColDef[]
  }, [contacts])
  return (
    <>
      <GlobalDataGrid
        apiRef={apiRef}
        rows={contacts || []}
        columns={columns}
        defaultGridDensity={'standard'}
        defaultFilterModel={defaultFilterModel}
        defaultSortModel={[{ field: 'name', sort: 'asc' }]}
        defaultVisibilityModel={{ source: false, timeCreated: false }}
        treeData={false}
        checkboxSelection={false}
        context="org_contacts"
        gridContainerSx={{
          position: 'relative',
          display: 'flex',
          maxHeight: '100vh',
          width: '100%',
          justifyContent: 'center',
          transition: 'all 0.3s ease-in-out',
          height: '100%',
        }}
      />
    </>
  )
}

export default OrgContacts
